<template>
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.67725C0 1.12496 0.447715 0.677246 1 0.677246H17C17.5523 0.677246 18 1.12496 18 1.67725C18 2.22953 17.5523 2.67725 17 2.67725H1C0.447716 2.67725 0 2.22953 0 1.67725Z" :fill="fill"/>
    <path d="M6.10352e-05 7.99981C6.10352e-05 7.44752 0.447776 6.99981 1.00006 6.99981H17.0001C17.5523 6.99981 18.0001 7.44752 18.0001 7.99981C18.0001 8.55209 17.5523 8.99981 17.0001 8.99981H1.00006C0.447777 8.99981 6.10352e-05 8.55209 6.10352e-05 7.99981Z" :fill="fill"/>
    <path d="M6.10352e-05 14.3226C6.10352e-05 13.7703 0.447776 13.3226 1.00006 13.3226H17.0001C17.5523 13.3226 18.0001 13.7703 18.0001 14.3226C18.0001 14.8748 17.5523 15.3226 17.0001 15.3226H1.00006C0.447777 15.3226 6.10352e-05 14.8748 6.10352e-05 14.3226Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "Burger",
    props: ['fill']
  }
</script>

<style scoped>

</style>